import React from "react";

const LogoIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4_550)">
      <path
        d="M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z"
        fill="#FFDA44"
      />
      <path
        d="M0 14C0 6.26806 6.26806 0 14 0C21.7319 0 28 6.26806 28 14"
        fill="#338AF3"
      />
    </g>
    <defs>
      <clipPath id="clip0_4_550">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default LogoIcon;
